import { render, staticRenderFns } from "./CoursePlanningJuniorHighSchool.vue?vue&type=template&id=b56aeb9e&scoped=true&"
import script from "./CoursePlanningJuniorHighSchool.vue?vue&type=script&lang=js&"
export * from "./CoursePlanningJuniorHighSchool.vue?vue&type=script&lang=js&"
import style0 from "./CoursePlanningJuniorHighSchool.vue?vue&type=style&index=0&id=b56aeb9e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b56aeb9e",
  null
  
)

export default component.exports